// Rozdělí text odpovědi na Markdown a bloky ```sam-widget```.
export type Segment = { kind: 'md'; text: string } | { kind: 'widget'; json: string; closed: boolean; index: number };

export function splitWidgets(text: string): Segment[] {
  const out: Segment[] = [];
  const re = /```sam-widget[^\n]*\n?([\s\S]*?)(```|$)/g;
  let last = 0;
  let index = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push({ kind: 'md', text: text.slice(last, m.index) });
    out.push({ kind: 'widget', json: m[1], closed: m[2] === '```', index: m[2] === '```' ? index++ : -1 });
    last = m.index + m[0].length;
    if (!m[0].length) break;
  }
  if (last < text.length) out.push({ kind: 'md', text: text.slice(last) });
  return out.filter((s) => s.kind !== 'md' || s.text.trim());
}
